define("shared/components/shared/credentials/tiktok-refresh", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{this.closeModal}}
    @closable={{false}}
    as
    |modal|
  >
    <modal.card
      @portrait={{true}}
      @closeIcon={{false}}
    >
      <modal.card-header>
        <h2 class="o--modalHeader__title">{{t "tiktok.refresh.title"}}</h2>
        <p class="u--p__t__xs">{{t "tiktok.refresh.subtitle"}}</p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        <div class="tAC--status tAC--status--danger">
          <div class="u--row u--row--noCollapse">
            <div class="u--col__8">
              <div>
                <Shared::ProfileAvatar
                  @socialProfile={{this.tiktokProfile}}
                  @showPlatform={{true}}
                >
                  <span class="o--user__title u--text--hair u--text--danger">
                    {{this.tiktokProfile.nickname}}
                  </span>
                  <span class="o--user__desc u--text--danger">
                    {{t "shared_words.tiktok"}}
                  </span>
                </Shared::ProfileAvatar>
              </div>
            </div>
            <div
              class="o--btn o--btn--outline u--m__r__sm u--float--right u--text--danger"
              data-test-id="tiktok-refresh-button"
            >
              <span {{on "click" (set this "showTiktokRefreshConfirmationModal" true)}}>
                {{t "shared_words.refresh"}}
                {{svg-jar "refresh" class="o--icon u--m__l__xs"}}
              </span>
            </div>
          </div>
        </div>
  
        <div class="o--card u--m__t__md">
          <div class="o--cardBody u--p__lr">
            <p class="u--text--bold u--m__b">
              {{t "shared_phrases.feature_refresh_required.missing_features"}}
            </p>
            <ul class="u--listUnstyle u--row">
              <li class="u--col__6">
                {{svg-jar "warning" class="o--icon o--icon--danger u--m__b__xs"}}
                {{t "shared_phrases.publish_post"}}
              </li>
              <li class="u--col__6">
                {{svg-jar "warning" class="o--icon o--icon--danger u--m__b__xs"}}
                {{t "shared_words.linkinbio"}}
              </li>
            </ul>
          </div>
        </div>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @type="outline"
          @additional="block"
          @text={{t "shared_words.close"}}
          @onClick={{@closeTiktokRefreshModal}}
          data-test-id="tiktok-refresh-close-button"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  {{#if this.showTiktokRefreshConfirmationModal}}
    <Shared::Credentials::TiktokRefreshConfirm
      @handleClose={{set this "showTiktokRefreshConfirmationModal" false}}
      @refreshUnverifiedTiktok={{action "refreshUnverifiedTiktok"}}
    />
  {{/if}}
  
  */
  {
    "id": "kMobSsUw",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closable\"],[[30,0,[\"closeModal\"]],false]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\",\"@closeIcon\"],[true,false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,1],[\"tiktok.refresh.title\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,[28,[35,1],[\"tiktok.refresh.subtitle\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tAC--status tAC--status--danger\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n            \"],[10,0],[12],[1,\"\\n              \"],[8,[39,2],null,[[\"@socialProfile\",\"@showPlatform\"],[[30,0,[\"tiktokProfile\"]],true]],[[\"default\"],[[[[1,\"\\n                \"],[10,1],[14,0,\"o--user__title u--text--hair u--text--danger\"],[12],[1,\"\\n                  \"],[1,[30,0,[\"tiktokProfile\",\"nickname\"]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--danger\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"shared_words.tiktok\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"o--btn o--btn--outline u--m__r__sm u--float--right u--text--danger\"],[14,\"data-test-id\",\"tiktok-refresh-button\"],[12],[1,\"\\n            \"],[11,1],[4,[38,3],[\"click\",[28,[37,4],[[30,0],\"showTiktokRefreshConfirmationModal\",true],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"shared_words.refresh\"],null]],[1,\"\\n              \"],[1,[28,[35,5],[\"refresh\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"o--card u--m__t__md\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--bold u--m__b\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_phrases.feature_refresh_required.missing_features\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row\"],[12],[1,\"\\n            \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__b__xs\"]]]],[1,\"\\n              \"],[1,[28,[35,1],[\"shared_phrases.publish_post\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__b__xs\"]]]],[1,\"\\n              \"],[1,[28,[35,1],[\"shared_words.linkinbio\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,6],[[24,\"data-test-id\",\"tiktok-refresh-close-button\"]],[[\"@type\",\"@additional\",\"@text\",\"@onClick\"],[\"outline\",\"block\",[28,[37,1],[\"shared_words.close\"],null],[30,2]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showTiktokRefreshConfirmationModal\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@handleClose\",\"@refreshUnverifiedTiktok\"],[[28,[37,4],[[30,0],\"showTiktokRefreshConfirmationModal\",false],null],[28,[37,9],[[30,0],\"refreshUnverifiedTiktok\"],null]]],null],[1,\"\\n\"]],[]],null]],[\"modal\",\"@closeTiktokRefreshModal\"],false,[\"shared/modal\",\"t\",\"shared/profile-avatar\",\"on\",\"set\",\"svg-jar\",\"shared/ui/button\",\"if\",\"shared/credentials/tiktok-refresh-confirm\",\"action\"]]",
    "moduleName": "shared/components/shared/credentials/tiktok-refresh.hbs",
    "isStrictMode": false
  });

  let TiktokRefresh = (_class = class TiktokRefresh extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "tiktok", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);
    }

    get socialProfiles() {
      return this.auth.socialProfiles;
    }

    get tiktokProfile() {
      var _this$router$currentR;

      if (this.args.tiktokProfile) {
        return this.args.tiktokProfile;
      }

      const tiktokSuccessProfileId = (_this$router$currentR = this.router.currentRoute.queryParams) === null || _this$router$currentR === void 0 ? void 0 : _this$router$currentR.tiktok_success_connection;

      if (tiktokSuccessProfileId) {
        return this.socialProfiles.find(profile => profile.id === tiktokSuccessProfileId);
      }

      return false;
    }

    refreshUnverifiedTiktok() {
      const socialProfile = this.tiktokProfile;
      this.tiktok.loginWithLoginKitAccount(socialProfile);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshUnverifiedTiktok", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshUnverifiedTiktok"), _class.prototype)), _class);
  _exports.default = TiktokRefresh;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TiktokRefresh);
});